import { createFileRoute, redirect } from "@tanstack/react-router"

export const Route = createFileRoute("/w/$workspace/settings/")({
  beforeLoad: ({ params }) => {
    throw redirect({ to: "/w/$workspace/settings/general", params })
  },
})
